import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NotificationService } from '@app/services/notification.service';
import * as CONSTANTS from '@app/shared/form-zarpe/form.constants';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
@Component({
  selector: 'app-certificaciones',
  templateUrl: './certificaciones.component.html',
  styleUrls: ['./certificaciones.component.css']
})
export class CertificacionesComponent implements OnInit {
  constants = CONSTANTS.FORM_CONSTANTS.CREACION;
  page = 2;
  page1 = 3;
  nicEmbarcacion = new FormControl();
  datafile: String;
  constructor(
    private apollo: Apollo,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
  }

    /* 
   obtenerCertificadoTradicion(embNic:"40110079" usuarioDoc:"C-79519352"){
    certificadoBase64
  }*/
  obtenerCertificadoBase64(){
    const myCert = this.nicEmbarcacion.value;
    this.apollo
      .watchQuery<any>({
        query: gql`
        {
          obtenerCertificadoTradicion(
            embNic: "${myCert}"
            ) {
              certificadoBase64
          }
        }
      `,
      })
      .valueChanges.subscribe(({data}) => {
        this.datafile = data.obtenerCertificadoTradicion.certificadoBase64;
        const linkSource = 'data:application/pdf;base64,' + this.datafile;
        const downloadLink = document.createElement("a");
        const fileName = 'certificado'+ myCert +'.pdf';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      },(err) => {
        this.notificationService.showNotification('Error', 'Información no encontrada', 'danger')
        }
      
      );
}

/*
.valueChanges.subscribe(({ data, errors, loading }) => {
  this.embarcacion = data.obtenerEmbarcacionDetalle;
  console.log(this.embarcacion);
  this.cargarDataAlFormulario();
  console.log(this.listaCapacidades);
  console.log(this.embarcacion.raInspectecs);
this.loading = false;
}, );
*/
  // Función que abre la ventana del reporte en PDF
  openPdfDialog(): void {
    this.obtenerCertificadoBase64();

}
}
